import React from 'react';
import HeroBanner from '../HeroBanner';
import ImageNav from '../ImageNav';
import LeftTextRightPhoto from '../LeftTextRightPhoto';
import HomeFooter from '../HomeFooter';
import CarouselSection from '../CarouselSection';
import Modal from '../Modal';

// ============================================================================
// BLACK FRIDAY IMPORT - TEMPORARY
// Remove this import and the <BlackFridayModal /> component after sale ends
// ============================================================================
import BlackFridayModal from '../blackfriday/BlackFridayModal';


export const Home = () => {
    return (
        <div>
            {/* ============================================================================
                BLACK FRIDAY MODAL - TEMPORARY
                Remove after Black Friday sale ends
                ============================================================================ */}
            <BlackFridayModal />
            
            <HeroBanner />
            <ImageNav />
            
            <CarouselSection />
            <LeftTextRightPhoto />
          
            <HomeFooter />
      
 
        </div>
    );
};


